import * as React from 'react';
import * as Session from '../../service/Session';
import * as TF from '../../service/tradeflow';
import * as DTO from '../../service/DTOs';
import * as ChatState from './ChatState';

import moment from 'moment';
import { ChatTextMessage } from './ChatState';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons'



const iconTrash = <FontAwesomeIcon icon={faTrashAlt} />


type ChatHistoryProps = {
    syshdr: DTO.SystemHeader;
    user: Session.UserState;
    //xsrfToken?: string;
    idchat?: number;
    messages: ChatState.ChatTextMessage[];
    fetchHistory: () => void;
    readChatMessagesConfirm: () => Promise<void>;
    allHistoryLoaded: boolean;
    new_chat_messages: DTO.AgentTextMessage[];
};

//interface ChatHistoryState {
//    syshdr: DTO.SystemHeader;

//    user: Session.UserState;
//    messages: DTO.AgentTextMessage[];
//    currentMessage?: string;
//    allHistoryLoaded: boolean;
//}

export class ChatHistory extends React.Component<ChatHistoryProps> {
    panelElem: HTMLDivElement | null = null;
    topMessage?: ChatTextMessage;
    scrollAtBottom: boolean = true;
    notifyRead: boolean = false;
    split_idx:number = 0;

    constructor(props: ChatHistoryProps) {
        super(props);
        //this.state = {
        //    ...{ messages: [] }, ...{ user: props.user }, ...{ syshdr: props.syshdr }, allHistoryLoaded:false
        //};        
    }

    renderDateSplit(dateHdr: string) {
        return <li key={this.split_idx++} className='date-split'>
            {dateHdr}
        </li>
    }

    renderNewMessagesSplit(text: string) {
        return <li key={this.split_idx++} className='date-split'>
            {text}
        </li>
    }

    renderNoEarlierDataSplit(title: string) {
        return <li key={'chat-no-earl-msg'} className='date-split'>
            {title}
        </li>
    }

    renderMessage(message: ChatState.ChatTextMessage, today: moment.Moment, recent?: boolean) {
        let authorCap = undefined;

        if (!this.props.user.personalState) {
            authorCap = <div className={'author-title'}><strong>{this.props.user.identityState.userName}</strong></div>
        }
        else if (message.author.idperson != this.props.user.personalState.idperson) {
            let authorName = message.author.lastName + ' ' + message.author.firstName;
            let authorEntName = (message.author.entity ? message.author.entity.nickname : '');
            authorCap = <div className={'author-title'}><strong>{authorName}</strong><span className={'author-entity'}>{authorEntName}</span></div>
        }

        let mstTime = moment(message.messagetime).utc();

        let dateCap1 = mstTime.format('HH:mm');
        //let dateCap2 = mstTime > today ? '' : mstTime.format('DD.MM.YYYY');
        //let dateCap = mstTime > today ? <span>{dateCap1}</span> : <span>{dateCap2}<br />{dateCap1}</span>

        //let dateCap = mstTime > today ? mstTime.format('HH:mm') : mstTime.format('DD.MM.YYYY-HH:mm');
        let cls = this.props.user.personalState ? (message.author.idperson == this.props.user.personalState.idperson ? 'person-msg' : undefined) : undefined;

        let clsText = this.props.user.personalState ? (message.author.idperson == this.props.user.personalState.idperson ? 'person-message-text' : 'message-text') : 'message-text';
        let superCls = undefined;

        if (message.tags) {
            if (message.tags.includes('attention'))
                superCls = 'high-attention';
        }

        if (superCls)
            clsText = clsText + ' ' + superCls;

        let newMsgBuble = recent ? <span className="recent-msg"></span> : undefined;

        let removeBtn = this.props.user.identityState.isAdmin ? <div className='otc-impactor-btn-li-right' title='Удалить сообщение' onClick={(e) => this.onRemoveMsg(e, message.id)}>{iconTrash}</div> : undefined;
        //removeBtn = <div className='otc-impactor-btn-li-right' onClick={(e) => this.onRemoveMsg(e, message.id)}>{iconTrash}</div>

        return <li key={message.id}  ref={(ref) => message.liElem = ref}> 
            {authorCap}
            <div className='time-field'>{newMsgBuble}<span>{dateCap1}</span></div>
            <div className={clsText}>{message.messagetext}{removeBtn}</div>            
        </li>
    }

    onRemoveMsg(event: any, idmessage: number) {
        event.preventDefault();
        this.removeMessage(idmessage);
    }

    private removeMessage(idmessage: number) {
        if (idmessage <= 0 ) {
            return;
        }
        else {
            TF.RemoveTextMessage(this.props.idchat, idmessage);
            //this.setState({
            //    currentMessage: ''
            //});            
        }
    }

    //processIncomingTextMessage(that: ChatHistory, message: DTO.AgentTextMessage) {
    //    if (message.idchat != this.props.idchat)
    //        return {};

    //    let messages = that.props.messages;
    //    messages.push(message);
    //    let cmsg = this.props.user.personalState ? (message.idauthor == this.state.props.personalState.idperson ? '' : that.props.currentMessage) : that.state.currentMessage;

    //    that.setState({
    //        messages: messages,
    //        currentMessage: cmsg
    //    });
    //    that.scrollDown(that);
    //    //that.focusField(that);

    //    return {};
    //}

    groupBy(list: ChatState.ChatTextMessage[], keyGetter: (msg: ChatState.ChatTextMessage) => string) {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return map;
    }

    private scrollDown(that: ChatHistory) {
        let div = that.panelElem;
        if (div) {
            const maxScrollTop = div.scrollHeight - div.clientHeight;
            div.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;

            if (this.props.readChatMessagesConfirm && !this.notifyRead && this.props.new_chat_messages.length > 0) {
                let _that = this;
                _that.notifyRead = true;
                setTimeout(function () {
                    _that.props.readChatMessagesConfirm().then(() => _that.notifyRead = false).catch(() => _that.notifyRead = false);
                }.bind(this), 3000)
            }
        }
    }


    componentWillUpdate(nextProps: ChatHistoryProps) {
        let historyChanged = nextProps.messages !== this.props.messages;

        this.scrollAtBottom = false;
        this.topMessage = undefined;

        if (historyChanged && this.panelElem) {

            //const { messageList } = this.refs;
            //console.log('historyChanged 2');
            const scrollPos = this.panelElem.scrollTop;
            if (this.props.messages.length == 0)
                this.topMessage = undefined;
            else {
                this.topMessage = nextProps.messages[nextProps.messages.length - this.props.messages.length - 1];
            }
            //this.topLiElem = this.props.messages[0].liElem;
            const scrollBottom = (this.panelElem.scrollHeight - this.panelElem.clientHeight);
            this.scrollAtBottom = (scrollBottom <= 0) || (scrollPos === scrollBottom);
        }
    }

    componentDidUpdate() {        
        if (this.scrollAtBottom) {
            this.scrollDown(this);
        }
        else {
            if (this.topMessage && this.topMessage.liElem) {
                this.topMessage.liElem.scrollIntoView();
            }
        }
    }

    componentDidMount() {
        this.scrollDown(this);
    }

    //componentDidMount() {
    //    TF.DataProcessBinding(this, { type: 'SYS.MSG.messages', delegate: (msgs: DTO.AgentTextMessage[]) => this.processTopMessages(msgs) });
    //    this.fetchHistory();
    //}

    onScroll = () => {
        let div = this.panelElem;
        if (div) {
            const scrollTop = div.scrollTop;
            const scrollHeight = div.scrollHeight;
            const clientHeight = div.clientHeight;
            
            if (scrollTop === 0 && scrollHeight > clientHeight) {
                //console.log('onScroll');
                this.props.fetchHistory();
            }
        }
    };

    render() {

        const grouped = this.groupBy(this.props.messages, msg => moment(msg.messagetime).utc().format('DD.MM.YYYY')) as Map<string, ChatState.ChatTextMessage[]>;

        let REFERENCE = this.props.syshdr.time ? moment(this.props.syshdr.time) : moment();
        var TODAY = REFERENCE.clone().utc().startOf('day');

        let topMostMsg = this.props.allHistoryLoaded ? this.renderNoEarlierDataSplit('Начало истории сообщений') : undefined;
        let id_list = this.props.new_chat_messages.map(x => x.id).sort();
        let min_id_new = id_list.length > 0 ? id_list[0] : undefined;

        
        let stockpile: JSX.Element[] = [];
        grouped.forEach((val, key) => {
            stockpile.push(this.renderDateSplit(key));
            val.forEach((message, idx) => {
                if (min_id_new && min_id_new == message.id)
                    stockpile.push(this.renderNewMessagesSplit('Новые сообщения'));

                stockpile.push(this.renderMessage(message, TODAY, min_id_new ? message.id >= min_id_new : false));
            });
            //val.map(message => stockpile.push(this.renderMessage(message, TODAY)));
        });

        //{ this.state.messages.map(message => this.renderMessage(message, TODAY)) }

        return <div className='panel panel-default'>
            <div className={'panel-body otc-panel-chat'} ref={(panel) => { this.panelElem = panel }} onScroll={this.onScroll}>
                <ul>
                    {topMostMsg}
                    {stockpile}
                </ul>
            </div>
        </div>;
    }

}